import type { FC } from 'react';

import type { IconProps } from './types';

const Add: FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M512 0c-44.648 0-80.842 36.195-80.842 80.842v350.316H80.842C36.194 431.158 0 467.353 0 512c0 44.648 36.195 80.842 80.842 80.842h350.316v350.316c0 44.648 36.195 80.842 80.842 80.842 44.648 0 80.842-36.195 80.842-80.842V592.842h350.316c44.648 0 80.842-36.195 80.842-80.842 0-44.648-36.195-80.842-80.842-80.842H592.842V80.842C592.842 36.194 556.647 0 512 0z"
      fill={color}
    />
  </svg>
);

export default Add;
